/**
 *
 * Column Container Script
 *
 */

class ColumnContainer {
    constructor(elem) {
        this.elem = elem;
        this.CardHeadlines = this.elem.querySelectorAll('.card__headline');
    }

    init() {
        if (this.CardHeadlines.length > 0) {
            this.headlineWatcher();
        }
    }

    /**
     * @TODO Describe what this function does
     */
    headlineWatcher() {
        let heighestHeadline = 0;

        for (const cardHeadline of this.CardHeadlines) {
            if (cardHeadline.offsetHeight > heighestHeadline) {
                heighestHeadline = cardHeadline.offsetHeight;
            }
        }

        const headlineProperty = `${heighestHeadline / 10}rem`;
        this.elem.style.setProperty('--headline-min-block-size', headlineProperty);
    }
}

export default ColumnContainer;
